var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.authed || _vm.allowUnauth)?[_c('router-view'),_c('token-manager')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }